function getInitials(name) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);

  const a = parts[0]?.[0] || "U";
  const b = parts.length > 1 ? parts[1]?.[0] || "" : parts[0]?.[1] || "";

  return (a + b).toUpperCase();
}

const PROVINCES = [
  { code: "AB", color: "#D80621", emoji: "🫎" },
  { code: "BC", color: "#d806a4", emoji: "🏔️" },
  { code: "MB", color: "#7a06d8", emoji: "🦬" },
  { code: "NB", color: "#2d06d8", emoji: "🌲" },
  { code: "NL", color: "#06a7d8", emoji: "🐟" },
  { code: "NS", color: "#06d892", emoji: "⚓" },
  { code: "ON", color: "#06d818", emoji: "🦫" },
  { code: "PE", color: "#b8d806", emoji: "🏝️" },
  { code: "QC", color: "#88d806", emoji: "⚜️" },
  { code: "SK", color: "#d87d06", emoji: "🌾" },
  { code: "NT", color: "#06d8cd", emoji: "🌌" },
  { code: "NU", color: "#9606d8", emoji: "🐻‍❄️" },
  { code: "YT", color: "#d84206", emoji: "❄️" },
];

export function loonlogAvatarSvg(name, province) {
  const initials = getInitials(name);

  // Find the province object to get the specific emoji
  const provCode = (province || "").toUpperCase();
  const provData = PROVINCES.find((p) => p.code === provCode);
  const watermarkEmoji = provData ? provData.emoji : "🍁";

  const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="320" height="320" viewBox="0 0 320 320">
  <rect width="320" height="320" fill="#fbeff0" />
  
  <g>
    <text x="160" y="255" font-size="240" text-anchor="middle" opacity="0.2">${watermarkEmoji}</text>

    <text x="160" y="198"
          font-size="120"
          font-family="system-ui, -apple-system, Segoe UI, Roboto, Arial"
          font-weight="500"
          fill="#616161ff"
          text-anchor="middle">${initials}</text>
  </g>
</svg>`.trim();

  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}
